<template>
    <div class="modal-mask" @click="showIntroduction" v-if="introductionState">
      <div class="modal-wrapper">
        <div class="modal-container" @click.stop>
          <div class="modal-header">
            <a class="fos--logo" href="http://www.fosopenscouting.be/nl" target="_blank"></a>
            <h3>Antwerpen telt zes eenheden binnen de koepel van FOS Open Scouting.</h3>
          </div>
          <div class="modal-body">
              <p>De eenheden bevinden zich in verschillende wijken binnen het Antwerpse. <br>Ze kennen elk hun eigen verhaal, achtergrond en samenstelling. Voor elk wat wils! Wil jij meer weten over een eenheid? Klik dan op de link naar de eigen websites of neem contact op via e-mail.</p>
          </div>
          <div class="modal-footer">
            <button class="modal-default-button" @click="showIntroduction">Naar de kaart</button>
            <br />
            <p class="copyright">Algemene informatie over onze missie, visie en werking kan je vinden op <a href="http://antwerpen.fossite.be" target="_blank" title="FOS Open Scouting Antwerpen">antwerpen.fossite.be</a> of op de algemene website <a href="http://fosopenscouting.be" target="_blank" title="FOS Open Scouting">fosopenscouting.be</a></p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    export default {
      name: 'Introduction',
      methods: mapActions(['showIntroduction']),
      computed: {
        ...mapGetters({
          introductionState: 'showIntroduction'
        }),
        markerClassName () { return 'marker marker-' + this.entity.id }
      },
      mounted: function () {
        document.addEventListener('keydown', (e) => {
          if (this.show && e.keyCode === 27) {
            this.closeModal()
          }
        })
      }
    }
</script>

<style scoped>

h3 {
  font-size: 18px;
  font-family: 'AndesBold', Helvetica, Arial, sans-serif;
  color: #005C9C;
  padding-top: 60px;
  max-width: 400px;
  margin: 0 auto;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 90%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  border-radius: 14px;
  color: #005C9C;
  text-align: center;
}

.modal-body {
  margin: 20px 0;
  padding: 0;
  font-size: 10px;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-header,
.modal-body,
.modal-footer {
  border: 0;
  text-align: center;
  position: relative;
  font-family: 'AndesBook', Helvetica, Arial, sans-serif;
}

.modal-footer {
  flex-direction: column;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-footer > div {
  width: 100%;
  display: inline-block;
}

.modal-default-button {
  background-color: #BED13A;
  border-radius: 8px;
  color: #fff;
  font-size: 18px;
  text-transform: uppercase;
  font-family: 'AndesBold', Helvetica, Arial, sans-serif;
  padding: 5px 10px;
  cursor: pointer;
  border: 0;
}

.fos--logo {
  background: url('../../assets/images/logo.svg');
  background-repeat: no-repeat;
  display: inline-block;
  width: 80px;
  height: 80px;
  background-size: contain;
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
}

.copyright {
  font-size: 13px;
  margin-top: 20px;
}

.copyright a {
  color: #BED13A;
}

@media all and (min-width: 992px) {
   .modal-container {
    width: 50%;
  }
}

@media all and (min-width: 678px) {
   h3 {
    font-size: 24px;
  }

  .modal-body {
    font-size: 19px;
  }

  .copyright {
    font-size: 16px;
  }

  .fos--logo {
    width: 140px;
    height: 140px;
    top: -90px;
  }

}

</style>


// WEBPACK FOOTER //
// src/components/introduction/Modal.vue